import { useState } from 'react';

const useWidgetEvents = () => {
  const [listStatusIsCollapse, setListStatusIsCollapse] = useState(false);
  return {
    ListStatus_isCollapse: listStatusIsCollapse,
    ListStatus_collapseButton: {
      onClick: (isCollapsed) => {
        setListStatusIsCollapse(isCollapsed);
      },
    },
  };
};

export default useWidgetEvents;
